import { PUSH_ALERT, REMOVE_ALERT, SET_TIMEOUT_ID } from '../constants/actions';
import { dispatch } from '../utils/generalUtils';

export function pushAlert(text: string, id: string, alertType: string) {
    return dispatch({
        type: PUSH_ALERT,
        text,
        id,
        alertType
    });
}

export function removeAlert(id?: string) {
    return dispatch({
        type: REMOVE_ALERT,
        id
    });
}

export function setTimeOutID(timeOutID: string) {
    return dispatch({
        type: SET_TIMEOUT_ID,
        timeOutID
    });
}
